"use strict";
window.theme = window.theme || {}
theme.medalFormCtaProfiling = function() {
    function medalFormCtaProfiling() {
        this.selector = {
            btn_product_page: document.querySelector('.product-medal-form'),
            open_medal: document.querySelector('.product-medal-form > button.medal'),
            login_page: document.querySelector('.product-medal-form > button.login'),
            homepage_slider: document.querySelectorAll('.homepage-slider-medal-form'),
            request_medal: document.querySelectorAll('.my-collection-collection-product-details .my-collection-decanter-buttons > button:not(.d-none)'),
            medal_product_decanter: document.querySelectorAll('.medal-form-decanter-product'),
            register_decanter: document.querySelectorAll('.my-collection-add-decanter')
        }
        this.container = {
            customer_login: document.querySelector('.medal-form-cta-profiling')
        }
        this.login = {
            right_panel: document.querySelector('#right-panel'),
            content: document.querySelector('#right-panel .content'),
            close_panel: document.querySelector('#close-panel'),
            form_welcome_page: document.querySelector('#right-panel #form-welcome-page'),
            form_registration: document.querySelector('#right-panel #form-registration'),
            form_signin: document.querySelector('#right-panel #form-signin'),
            login_form: document.querySelector('#login-form')
        }

        this.load();
    }

    medalFormCtaProfiling.prototype.load = function() {
            var _ = this;
            let loginstatus = _.container.customer_login.getAttribute('data-customer-login') === 'true' ? true : false;
            let time_collection_decanter = _.container.customer_login.getAttribute('data-collection-decanter') !== '' ? true : false;
            if(_.selector.login_page)_.selector.login_page.classList.add('d-none');    
            if(_.selector.btn_product_page)_.selector.btn_product_page.classList.add('d-none');    
            if(_.selector.open_medale)_.selector.open_medal.classList.add('d-none');
            let time_collection_handles = {
                "product": []
            };
            if(_.selector.btn_product_page) {
                let first_handle = _.selector.btn_product_page.getAttribute('data-time-collection-first-handle');              
                if(first_handle !== '') {
                    time_collection_handles["product"].push({"handle":`${first_handle}`});
                }
            }
            if(_.selector.homepage_slider) {
                _.selector.homepage_slider.forEach(e => {
                    let first_handle = e.getAttribute('data-time-collection-first-handle');
                    if(first_handle !== '') {
                        time_collection_handles["product"].push({"handle":`${first_handle}`});
                    }
                })
            
            }
            let array_time_collection_decanter = {
                "decanter": []
            }       
            if(loginstatus && time_collection_decanter) {
            array_time_collection_decanter = JSON.parse( _.container.customer_login.getAttribute('data-collection-decanter'));
            } 
            //Product belongs to time collection handle but user is not connected
            if(time_collection_handles.product.length>0 && !loginstatus) {
                _.selector.login_page.classList.remove('d-none');    
                _.selector.btn_product_page.classList.remove('d-none');    
            } 
            //Product belongs to time collection handle and user is connected
            if(array_time_collection_decanter.length>0 && loginstatus) {
                array_time_collection_decanter.forEach(decanter => {
                    time_collection_handles.product.forEach(handle => {
                        if(handle.handle === decanter) {
                            _.selector.open_medal.classList.remove('d-none');
                            _.selector.btn_product_page.classList.remove('d-none');    
                        } 
                        if(handle.handle === 'homepage-slider' && _.selector.homepage_slider.length>0) {
                            _.selector.homepage_slider.forEach(e => {
                                    e.classList.remove('d-none');
                                    e.querySelector('button').classList.remove('d-none');
                                    e.querySelector('input').classList.remove('d-none')
                                    e.querySelector('button').addEventListener('click',(event) => {                                       
                                        if(e.querySelector('input').value !== '') {
                                            event.preventDefault();
                                            theme.quickMedalDrawer.opendrawer(e.querySelector('input').value, true,'');
                                            if(theme.quickMedalDrawer.label.decanter_code) {
                                                theme.quickMedalDrawer.label.decanter_code.classList.add('focus');
                                            }
                                        }                                       
                                    })
                            })
                        }                      
                    })     
                })
            } 
            if(_.selector.request_medal.length>0) {
                _.selector.request_medal.forEach(el => {
                    el.addEventListener('click', () => {                        
                        theme.quickMedalDrawer.opendrawer(el.getAttribute('data-decanter-number'), true,el.getAttribute('data-product-handle'));
                        if(theme.quickMedalDrawer.label.decanter_code) {
                            theme.quickMedalDrawer.label.decanter_code.classList.add('focus');
                        }
                        dataLayer.push({ 
                            event: 'request_medal_form'
                        });
                    })                   
                })
            }
            if(_.selector.login_page) {
                _.selector.login_page.addEventListener('click', () => {
                    _.loginpopup();
                })
            }
            _.selector.register_decanter.forEach(btn => {
                btn.addEventListener('click', event => {
                    theme.quickMedalRegisterDrawer.opendrawer('','','');
                })
            })
    }
    medalFormCtaProfiling.prototype.loginpopup = function() {
        var _ = this;
        _.login.right_panel.classList.remove('right-panel-close');
        _.login.right_panel.classList.add('right-panel');
        _.login.content.classList.add('open-panel');
        _.login.content.classList.remove('close-panel');
        _.login.close_panel.classList.remove('d-none');
          document.body.classList.remove('d-none');
        _.login.form_welcome_page.classList.add('d-none');
        _.login.form_registration.classList.add('d-none');
        _.login.form_signin.classList.remove('d-none');
        _.login.login_form.classList.remove('hide');    
    }
    theme.medalFormCtaProfiling = new medalFormCtaProfiling;

}

theme.medalFormCtaProfiling();
